<nz-table
  #sortTable
  [nzData]="(BIPs$ | async)?.result?.items ?? []"
  [nzFrontPagination]="false"
  [nzLoading]="loading"
  [nzTotal]="(BIPs$ | async)?.result?.totalRows || 0"
  [(nzPageIndex)]="pageIndex"
  [nzPageSize]="pageSize"
  (nzQueryParams)="onQueryParamsChange($event)"
  [nzScroll]="{ x: '700px', y: 'calc(100vh - 290px)' }">
  <thead>
    <tr>
      <th
        scope="col"
        [nzSortFn]="true"
        [title]="listOfColumn[1].title"
        [nzColumnKey]="listOfColumn[1].key">
        {{ listOfColumn[1].title }}
      </th>
      <th
        scope="col"
        [nzSortFn]="true"
        [title]="listOfColumn[2].title"
        [nzColumnKey]="listOfColumn[2].key">
        {{ listOfColumn[2].title }}
      </th>
      <th
        scope="col"
        [nzSortFn]="true"
        [title]="listOfColumn[3].title"
        [nzColumnKey]="listOfColumn[3].key">
        {{ listOfColumn[3].title }}
      </th>
      <th
        scope="col"
        [nzSortFn]="true"
        [title]="listOfColumn[4].title"
        [nzColumnKey]="listOfColumn[4].key">
        {{ listOfColumn[4].title }}
      </th>
      <th
        scope="col"
        [nzSortFn]="true"
        [title]="listOfColumn[5].title"
        [nzColumnKey]="listOfColumn[5].key">
        {{ listOfColumn[5].title }}
      </th>
      <th
        scope="col"
        [title]="listOfColumn[6].title"
        [nzColumnKey]="listOfColumn[6].key"
        nzWidth="100px">
        {{ listOfColumn[6].title }}
      </th>
      <th
        scope="col"
        zWidth="120px"
        [title]="listOfColumn[7].title"
        [nzColumnKey]="listOfColumn[7].key">
        {{ listOfColumn[7].title }}
      </th>
      <th scope="col" nzWidth="120px" nzRight>{{ listOfColumn[8].title }}</th>
    </tr>
  </thead>

  <tbody>
    <tr *ngFor="let data of sortTable.data; let i = index">
      <td class="with-icon">{{ data.studentName }}</td>
      <td [title]="data.organizationName">
        {{ data.organizationName }}
      </td>
      <td [title]="data.enrollId">{{ data.enrollId }}</td>
      <td [title]="data.caseOwnerName">{{ data.caseOwnerName }}</td>
      <td>
        <div
          class="status"
          [ngClass]="data.statusId === 1 ? 'active' : 'inactive'">
          <span>{{ data.statusId === 1 ? 'Open' : 'Close' }}</span>
        </div>
      </td>
      <td>{{ '-' }}</td>
      <td nZTitle>
        <nz-avatar-group *ngIf="data.caseMembers.length > 0">
          <span
            *ngFor="
              let member of getMemberList(data.caseMembers).slice(0, 3);
              let i = index
            "
            [title]="data.caseMembers[i].caseMemberName">
            <nz-avatar [nzText]="member"></nz-avatar>
          </span>
          <nz-avatar
            nzText="+3"
            *ngIf="data.caseMembers.length > 3"
            nz-dropdown
            [nzDropdownMenu]="menu"
            class="avatar-link"
            nzTrigger="click"
            [nzPlacement]="'bottomLeft'"></nz-avatar>
          <nz-dropdown-menu #menu="nzDropdownMenu">
            <ul nz-menu class="avatar-dropdown">
              <li
                nz-menu-item
                nzClickHide="false"
                class="action-list-item"
                *ngFor="let member of data.caseMembers">
                <span>{{ member.caseMemberName }}</span>
              </li>
            </ul>
          </nz-dropdown-menu>
        </nz-avatar-group>
      </td>
      <td nzRight>
        <div class="action-btn-wrapper">
          <button
            nz-button
            nz-dropdown
            [nzDropdownMenu]="menu"
            nzTrigger="click"
            [nzPlacement]="'bottomLeft'"
            nzType="text"
            type="button"
            class="action-btn">
            <svg-icon
              [title]="'More options'"
              src="/assets/icon/icon-more.svg"
              class="icon s-20"
              aria-label="More"></svg-icon>
          </button>
          <nz-dropdown-menu #menu="nzDropdownMenu">
            <ul nz-menu>
              <li
                nz-menu-item
                nzClickHide="false"
                class="action-list-item"
                *ngIf="data.statusId !== 1"
                tabindex="0"
                (click)="updateCaseStatus(data.caseId, data.statusId)"
                (keydown.enter)="updateCaseStatus(data.caseId, data.statusId)">
                <svg-icon
                  src="/assets/icon/icon-reopen.svg"
                  class="icon s-16 fw-500"
                  aria-label="Reopen"></svg-icon>
                <span class="text s-14">Reopen Case</span>
              </li>
              <li
                nz-menu-item
                nzClickHide="false"
                class="action-list-item"
                *ngIf="data.statusId === 1"
                tabindex="0"
                (click)="updateCaseStatus(data.caseId, data.statusId)"
                (keydown.enter)="updateCaseStatus(data.caseId, data.statusId)">
                <svg-icon
                  src="/assets/icon/icon-close-case.svg"
                  class="icon s-16 fw-500"
                  aria-label="Close Case"></svg-icon>
                <span class="text s-14">Close Case</span>
              </li>
            </ul>
          </nz-dropdown-menu>
        </div>
      </td>
    </tr>
  </tbody>
</nz-table>
